<template>
  <div>
    <page-layout>
      <error-global ref="ErrorGlobal"></error-global>

      <div class="container">
        <div class="row">
          <div class="col-16">
            <h1>Estimates</h1>
          </div>
          <div class="col-8">
            <div class="header-right">
              <a href="#" @click.prevent="searchShow = !searchShow"><i class="fas fa-search"></i> Search</a>
            </div>
          </div>
        </div>

        <div class="box" v-if="searchShow">
          <form class="search">
            <input class="form-control form-control-line search__input" type="text" placeholder="Search..." v-model="searchKeyword">
            <button class="btn btn-primary btn-md search__btn" type="submit" @click.prevent="searchSubmit">Submit</button>
            <button class="btn btn-default btn-md ml-2" type="button" v-if="searchSubmitted" @click="searchReset"><i class="fas fa-times"></i></button>
          </form>
        </div>

        <tabs :tabs="tabs" :active="tabActive" v-on:on-click-tab="onClickTab"></tabs>

        <div class="estimate" v-for="(estimate, $index) in estimates" :key="$index" @click="viewEstimate(estimate.url_public)">
          <div class="row">
            <div class="col-12">
              {{ estimate.custom_number }}
              <div class="estimate__date">{{ estimate.date_added_text }}</div>
              <div class="estimate__job">{{ estimate.job.title ? estimate.job.title : 'Job for ' + estimate.customer.name }}</div>
            </div>
            <div class="col-12 text-right">
              {{ estimate.total_text }}
              <div class="estimate__status" :class="getStatusClass(estimate.status)">{{ estimate.status_text }}</div>
            </div>
          </div>
        </div>

        <infinite-loading @infinite="getAll" :distance='100'>
          <div slot="no-more" class="text-sec margin-bottom"> </div>
        </infinite-loading>

      </div>

    </page-layout>
  </div>
</template>

<script>
import ErrorGlobal from '@/components/ErrorGlobal.vue';
import PageLayout from '@/components/PageLayout.vue';
import Tabs from '@/components/Tabs.vue';
import Http from '@/lib/http';
import InfiniteLoading from 'vue-infinite-loading';
import { STATUS } from '@/views/estimates/config';

export default {
  name: 'estimates',
  components: {
    ErrorGlobal,
    PageLayout,
    Tabs,
    InfiniteLoading,
  },
  props: {},
  data() {
    return {
      tabs: [
        {
          id: 'all',
          name: 'All',
          nameExtra: '0',
          url: 'estimates',
        },
        {
          id: 'pending',
          name: 'Pending',
          nameExtra: '0',
          url: 'estimates?tab=pending',
        },
        {
          id: 'accepted',
          name: 'Accepted',
          nameExtra: '0',
          url: 'estimates?tab=accepted',
        },
      ],
      tabActive: 'all',

      estimates: [],
      estimates_summary: null,
      page: 1,

      searchShow: false,
      searchKeyword: '',
      searchSubmitted: false,
    };
  },
  created() {
    this.STATUS = STATUS;
    if (this.$route.query.tab) {
      this.tabActive = this.$route.query.tab;
    }
  },
  methods: {
    getAll($state) {
      if (!this.page) {
        return;
      }

      let status = '';
      if (this.tabActive === 'pending') {
        status = STATUS.SUBMITTED;
      } else if (this.tabActive === 'accepted') {
        status = [STATUS.ACCEPTED, STATUS.INVOICED].join(',');
      }

      const queryParams = {
        page: this.page,
        status,
      };
      if (this.searchKeyword) {
        queryParams.search = this.searchKeyword;
      }

      Http.get('estimates/main', queryParams).then((response) => {
        // tabs count
        const statusCount = response.data.status_count;
        let statusCountTotal = 0;
        Object.values(statusCount).forEach((val) => {
          statusCountTotal += parseInt(val, 10);
        });
        this.tabs.map((tab) => {
          const row = tab;
          if (tab.id === 'pending') {
            row.nameExtra = statusCount[STATUS.SUBMITTED];
          } else if (tab.id === 'accepted') {
            row.nameExtra = parseInt(statusCount[STATUS.ACCEPTED], 10) + parseInt(statusCount[STATUS.INVOICED], 10) + parseInt(statusCount[STATUS.CANCELED], 10);
          } else if (tab.id === 'all') {
            row.nameExtra = statusCountTotal;
          }
          return row;
        });

        // estimates
        const dataEstimates = response.data.estimates;
        dataEstimates.map((estimate) => {
          const row = estimate;
          return row;
        });
        this.estimates.push(...dataEstimates);

        $state.loaded();
        if (response.data.paginator.next) {
          this.page = response.data.paginator.next;
        } else {
          this.page = 0;
          $state.complete();
        }
      }).catch((error) => {
        if (error.response) {
          this.$refs.ErrorGlobal.show(error.response.data.error.message);
        }
      });
    },
    getStatusClass(status) {
      switch (status) {
        case STATUS.SUBMITTED:
          return 'estimate__status--pending';
        case STATUS.ACCEPTED || STATUS.INVOICED:
          return 'estimate__status--accepted';
        case STATUS.CANCELED:
          return 'estimate__status--canceled';
        default:
          return '';
      }
    },
    viewEstimate(urlPublic) {
      // this.$router.push({ path: `estimates/view/${estimateId}` });
      window.location.href = urlPublic;
    },
    onClickTab(tab) {
      this.page = 1;
      this.estimates = [];
      this.tabActive = tab.id;
      this.getAll();
    },
    reset() {
      this.page = 1;
      this.estimates = [];
    },
    searchSubmit() {
      if (!this.searchKeyword) {
        return;
      }
      this.searchSubmitted = true;
      this.reset();
      this.getAll();
    },
    searchReset() {
      this.searchKeyword = '';
      this.searchSubmitted = false;
      this.reset();
      this.getAll();
    },
  },
};
</script>

<style scoped>
.box-summary__value {
  font-size: 20px;
}

/* estimate */
.estimate {
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 15px;
  padding-bottom: 15px;
  cursor: pointer;
}
.estimate:last-child {
  border-bottom: none;
  margin-bottom: 100px;
}
.estimate__date,
.estimate__job {
  color: #858585;
}
.estimate__status {
  font-size: 14px;
}
.estimate__status--pending {
  color: #00a4ed;
}
.estimate__status--canceled {
  color: #e44747;
}
.estimate__status--accepted {
  color: #10bc82;
}

.header-right {
  text-align: right;
  padding-top: 5px;
}
.search {
  display: flex;
}
.search__input {
  margin-right: 20px;
  height: 40px;
}
</style>
